import styled, { css } from 'styled-components'
import { colors } from '@chegg-ui/theme'
import { fanta, PrimaryButton } from '@chegg/fanta'

export const TourWrapper = styled.div`
  background-color: ${colors.white};
  min-width: 300px;
`

export const TourContainer = styled.section``

export const TourBody = styled.div``

export const TourDot = styled.span<{ isSelected: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;

  ${({ isSelected }) =>
    isSelected
      ? css`
          background-color: ${colors.cheggOrange};
        `
      : css`
          border: 1px solid ${colors.grey};
        `}
`

export const TourFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 92px;
  margin: 0 ${fanta.spacing.xl};
`
export const TourStepDotsContainer = styled.div`
  display: flex;

  > ${TourDot}: not(: last-child) {
    margin-right: ${fanta.spacing.xxs};
  }
`
export const TourCTAButton = styled(PrimaryButton)``
